import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getVisibleTrips } from '../services/tripsService';
import type { Trip } from '../types/client';
import { tripWebSlug } from './tripUrl';

/**
 * Replace a UUID (or stale slug) trip segment with the current web-only slug.
 * Create route `/trips/new` is left alone.
 */
export function useCanonicalTripUrl(trip: Trip | null): void {
  const { tripId } = useParams<{ tripId?: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!trip || !user?.sub || !tripId || tripId === 'new') return;
    const slug = tripWebSlug(trip, getVisibleTrips(user.sub));
    if (tripId === slug) return;
    const prefix = `/trips/${tripId}`;
    if (!location.pathname.startsWith(prefix)) return;
    const rest = location.pathname.slice(prefix.length);
    navigate(`/trips/${slug}${rest}${location.search}`, { replace: true });
  }, [trip, user?.sub, tripId, location.pathname, location.search, navigate]);
}
